export const LOGOS: { logoPath: string; alt: string }[] = [
    {
        logoPath: '/static/nihlogo.png',
        alt: 'NIH Logo',
    },
    {
        logoPath: '/static/utlogo.png',
        alt: 'UT Logo',
    },
    {
        logoPath: '/static/mcgilllogo.png',
        alt: 'McGill Logo',
    },
    {
        logoPath: '/static/fiulogo.png',
        alt: 'FIU Logo',
    },
    {
        logoPath: '/static/oxfordlogo.png',
        alt: 'Oxford Logo',
    },
    {
        logoPath: '/static/stanfordlogo.png',
        alt: 'Stanford Logo',
    },
    {
        logoPath: '/static/origamilogo.png',
        alt: 'Origami Labs Logo',
    },
];
